import { useAds } from 'hooks/use-ads';
import React from 'react';
import { replacePLChars } from 'helpers/string-tools';

interface AdSlotSSRProps {
    name: string;
    className?: string;
    resizable?: boolean;
    lazy?: boolean;
}

const AdSlotSSR: React.FC<AdSlotSSRProps> = ({ name, className, resizable = false, lazy = false }) => {
    const id = `ad-${name}`;
    const ads = useAds();
    const network = ads?.adpConfig?.adpNetwork;
    const [site, area] = ads?.target?.split('/') ?? [];
    const disabledSlots = ads?.disabledSlots ?? [];
    const disabled = !ads?.enabled || disabledSlots.includes(name);
    let keywords = '';
    let keyvalues = '';

    if (ads?.keywords) {
        keywords = `&kwrd=${encodeURIComponent(ads?.keywords.join('+'))}&`;
    }

    if (ads?.keyvalues) {
        const amp = keywords ? '' : '&';

        keyvalues = `${amp}${Object.entries(ads?.keyvalues).map(([key, val]) => `${key}=${val}`).join('&')}&`;
    }

    if (disabled) {
        return null;
    }

    const url = `https://csr.onet.pl/${network}/csr-006/adslot.html?site=${site}&area=${area}${keywords}${keyvalues}slot0=${name}&id0=${id}&nid=${network}&cdf=1`;

    return (
        <div
            id={id}
            data-slot={name}
            data-prop-lazy={lazy || void 0}
            data-resizable={resizable || void 0}
            data-autoslot="0"
            className={className}
            dangerouslySetInnerHTML={{ __html: `
                <cdf:application name="${id}" onError="discard" controller="${replacePLChars(url.replace(/\s/g, ''))}" controller-type="http" cache="min" timeout="1000" ></cdf:application>
            ` }}
        />
    );
};

export default AdSlotSSR;
